export default "__VITE_ASSET__C6JV6lJI__"